import axios from '../../../axios';
import IRecruiterSearchFilterDTO from '../types/IRecruiterSearchFilterDTO';

const url = '/recruitersearch/api/';

export const getRecruitersFromWorkspace = (data: IRecruiterSearchFilterDTO) =>
  axios.post(`${url}_search/recruiters/workspace`, data);

export const postAdvancedQuery = (query: IRecruiterSearchFilterDTO) =>
  axios.post(`${url}_search/recruiters/advanced`, query);

export const teamStats = (teamIds: string[]) => axios.post(`${url}recruiters/team-stats`, teamIds);

// export const getTeamsSuggestions = (team: string) =>
//   axios.get(`${url}teams/suggestions/all?query=${team}`);

export const getRecruitersListByEmailIds = (recruiterEmails: string[]) =>
  axios.post(`${url}recruiters/get-details-by-ids`, recruiterEmails);

export const usersAdvanceFilterQuery = (query: string) =>
  axios.get(`/api/search/recruiters/advanced?search=${query}`);
